import { Injectable, inject } from '@angular/core';
import { NgrxHttpClient } from '@library/utils/services/http-service';

@Injectable({ providedIn: 'root' })
export class ScenariosService {
  private readonly http = inject(NgrxHttpClient);

  loadScenarios(homeId: string, deviceTypes?: string[], filter?: string[]) {
    const params: {home_id: string, device_types?: string[], filter?: string[]} = {
      home_id: homeId,
    };
    if (deviceTypes) {
      params.device_types = deviceTypes;
    }
    if (filter) {
      params.filter = filter;
    }
    return this.http.getSync('getscenarios', params);
  }

  setScenarios(params) {
    return this.http.postSync('setscenarios', params);
  }
}
